import {State} from '../types/state'

export const isItemOpened = (state: State, eventId: string) => state.layout.listItemOpened === eventId

export const isForceShowRibbons = (state: State) =>
  state.layout.forceShowRibbons || state.layout.settingsDisplayTabOpened
